import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { useDispatch } from 'react-redux'
import { FlexRow } from 'components/Flex'
import { DisabledTag, GreenTag } from 'components/Tag'
import { Spacer } from 'components/Utility'
import { BlueButton, GreyButton } from 'components/Button'
import { parseStoreStatus } from 'lib/helper'
import { closeModal } from 'reducks/modal/operations'
import { push } from 'connected-react-router'
import { switchStoreFromAdmin } from 'reducks/auth/operations'
import { db } from 'firebase/index'

type Props = {
  imageUrl: string
  name: string
  shopId: string
  status: string
  storeId: string
}

const StoreModal: FC<Props> = (props) => {
  const { imageUrl, name, shopId, status, storeId } = props

  const dispatch = useDispatch()

  return (
    <div>
      <FlexRow justifyContent={'start'}>
        <div className={styles.row__modal__image}>
          <img src={imageUrl} alt={name} />
        </div>
        <Spacer size={12} />
        <div>
          <p className={`${text.font_bold} ${text.font_large}`}>{name}</p>
          <Spacer size={8} />
          {status === 'public' && <GreenTag shape={'ellipse'} size={'large'} tagName={parseStoreStatus(status)} />}
          {status === 'private' && <DisabledTag shape={'ellipse'} size={'large'} tagName={parseStoreStatus(status)} />}
        </div>
      </FlexRow>
      <Spacer size={20} />
      <BlueButton
        label={'店舗アカウント情報を編集する'}
        onClick={() => {
          dispatch(push(`/admin/shops/${shopId}/account`))
          dispatch(closeModal())
        }}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={12} />
      <BlueButton
        label={'店舗基本情報を編集する'}
        onClick={() => {
          dispatch(push(`/admin/shops/${storeId}/information`))
          dispatch(closeModal())
        }}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={12} />
      <BlueButton
        label={'商品の受け渡しに関する設定を編集する'}
        onClick={() => {
          dispatch(push(`/admin/shops/${storeId}/settings`))
          dispatch(closeModal())
        }}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={12} />
      <BlueButton
        label={'ログインアカウントを作成する'}
        onClick={() => {
          dispatch(push(`/admin/shops/${storeId}/invite_owner`))
          dispatch(closeModal())
        }}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={12} />
      <BlueButton
        label={'この店舗に切り替える'}
        onClick={() => {
          dispatch(switchStoreFromAdmin(db.collection('stores').doc(storeId)))
          dispatch(closeModal())
        }}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={12} />
      <GreyButton label={'閉じる'} onClick={() => dispatch(closeModal())} size={'medium'} type={'outlined'} />
    </div>
  )
}

export default StoreModal
